<template>
	<div>
	<v-dialog persistent attach v-model="show" max-width="750" id="member-dialog">
      <v-card class="relative add-edit-wrapper" v-if="show">
        <div class="close-btn">
          <i class="material-icons" @click="closeDialog">
            clear
          </i>
        </div>
        <v-card-title class="pb-2 headline black--text justify-center">Please choose subscription period</v-card-title>
        <v-container grid-list-xl fluid class="mt-10">
          <div>
            <v-form v-model="validPaymentForm" class="org-assign-user-form" ref="form">
              <v-flex md12>
                <v-select
                    :label=" plan + ' Subscription Period*'"
                    :items="periodOptions"
                    hide-details
                    v-model="subscription_period"
                    required
                    class="mb-10"
                >
                </v-select>
              </v-flex>
              <v-card-actions class="d-flex flex-column pa-0 mb-30">
                <v-spacer></v-spacer>
                <v-btn
                  class="save-btn mb-16px"
                  :disabled="!validPaymentForm || loading"
                  @click="changeSubscription"
                >
                  Upgrade
                </v-btn>
                <v-btn class="cancel-btn" style="height: 50px !important" text @click="closeDialog">Cancel</v-btn>
              </v-card-actions>
            </v-form>
          </div>
          <v-spacer></v-spacer>
        </v-container>
      </v-card>
    </v-dialog>
	</div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  props: ['show', 'script', 'plan'],
  data () {
    return {
      validPaymentForm: false,
      subscription_period: '',
      periodOptions: ['Monthly', 'Yearly'],
      nameRules: [
        v => !!v || 'Name is required',
        v => (v && v.length <= 100) || 'Name must be less than 100 characters'
      ],
      phoneRules: [],
      card: '',
      elements: '',
      stripe: '',
      stripeAPIToken: '',
      loading: false
    }
  },
  computed: {
    ...mapGetters(['currentOrganization', 'paymentInformation']),
    isInvalid () {
      return !this.creditFormFields.line1 || !this.creditFormFields.city || !this.creditFormFields.state
    },
    hasPaymentMethod () {
      return !!(Object.keys(this.paymentInformation.card_info).length && this.paymentInformation.card_info.constructor === Object)
    },
    subscriptionPlan () {
      if (this.subscription_period === 'Yearly' && this.plan === 'Cloud') {
        return 'cloud_standard_yearly'
      } else if (this.subscription_period === 'Monthly' && this.plan === 'Cloud') {
        return 'cloud_standard_monthly'
      } else if (this.subscription_period === 'Yearly' && this.plan === 'Cloud+') {
        return 'cloud_plus_yearly'
      } else if (this.subscription_period === 'Monthly' && this.plan === 'Cloud+') {
        return 'cloud_plus_monthly'
      }
    }
  },
  methods: {
    closeDialog () {
    	this.$emit('closeDialog')
    },
    getBillingInfo (entityId) {
      if (!entityId) return
      this.$store.dispatch('getBillingInfo', entityId)
    },
    changeSubscription () {
      const payload = {
        organization_id: this.currentOrganization.entity_id,
        subscription_plan: this.subscriptionPlan,
        payment_method_id: this.paymentInformation.payment_method_id
      }
      this.loading = true
      this.$store.dispatch('changeSubscription', payload).then(data => {
        this.getBillingInfo(this.currentOrganization.entity_id)
        this.getUpcomingInvoices(this.currentOrganization.entity_id)
        this.loading = false
        this.closeDialog()
      })
    },
    getUpcomingInvoices (entityId) {
      if (!entityId) return
      this.$store.dispatch('getUpcomingInvoices', entityId)
    },
    setPeriod () {
      if (this.paymentInformation && this.paymentInformation.subscription_plan && this.paymentInformation.subscription_plan.includes('yearly')) {
        this.subscription_period = 'Yearly'
      } else if (this.paymentInformation && this.paymentInformation.subscription_plan && this.paymentInformation.subscription_plan.includes('monthly')) {
        this.subscription_period = 'Monthly'
      }
    }
  },
  mounted () {
    this.setPeriod()
  }
}
</script>
<style lang="scss">
.v-select__selections {
    color: #212338 !important;
    font-family: "gt_america_extended";
    font-size: 18px !important;
    letter-spacing: 0;
    line-height: 40px;
    font-weight: 500;
    margin-top: 2px;
  }
.v-select__selection {
    margin-bottom: 0px;
}
.v-input__slot {
    padding: 0px 10px !important;
    align-items: flex-end;
}
#card-element {
  background: #e6e6e6;
  margin: 0 0 10px 0 !important;
  padding: 16px !important;
  border-radius: 4px;
}
#card-errors {
  color: #ff5252 !important;
  margin: 0 !important;
  font-size: 12px;
  padding-left: 0 !important;
  padding-top: 2px !important;
}
</style>
